import { ListTodo, Clock, Calendar, Users, AlertTriangle, HelpCircle } from 'lucide-react'
import { useAuthStore } from '@/stores/authStore'

interface SuggestedActionsProps {
  onSelect: (message: string) => void
  disabled?: boolean
}

const supervisorSuggestions = [
  {
    icon: Users,
    label: 'Team workload',
    message: "How is the team's workload distributed right now?",
  },
  {
    icon: AlertTriangle,
    label: "What's overdue?",
    message: 'What tasks are overdue and need attention?',
  },
  {
    icon: Clock,
    label: 'Team hours this week',
    message: 'Show me hours logged by each team member this week',
  },
  {
    icon: Calendar,
    label: 'Upcoming deadlines',
    message: 'What statutory deadlines are coming up this month?',
  },
]

const memberSuggestions = [
  {
    icon: ListTodo,
    label: 'My priorities',
    message: 'What should I focus on today?',
  },
  {
    icon: HelpCircle,
    label: 'Help with task',
    message: 'Can you walk me through my current task?',
  },
  {
    icon: Clock,
    label: 'My hours this week',
    message: 'How many hours have I logged this week?',
  },
  {
    icon: Calendar,
    label: 'Upcoming deadlines',
    message: 'What deadlines do I have coming up?',
  },
]

export function SuggestedActions({ onSelect, disabled }: SuggestedActionsProps) {
  const { user } = useAuthStore()
  const suggestions = user?.role === 'supervisor' ? supervisorSuggestions : memberSuggestions

  return (
    <div className="px-4 pb-4">
      <p className="text-[10px] text-muted-foreground/60 uppercase tracking-wider font-medium mb-3">Quick actions</p>
      <div className="grid grid-cols-2 gap-2">
        {suggestions.map((suggestion) => {
          const Icon = suggestion.icon
          return (
            <button
              key={suggestion.label}
              onClick={() => onSelect(suggestion.message)}
              disabled={disabled}
              className="flex items-center justify-start gap-1.5 border border-border/50 hover:border-primary/40 hover:bg-primary/5 rounded-full px-3 py-1.5 text-xs transition-all duration-200 h-auto font-normal disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Icon className="h-3 w-3 text-primary/60" />
              {suggestion.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
